import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { Container, Row, Col, Box } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import { SectionWrap } from './bottom-banner.style'

const BottomBannerArea = ({ sectionStyle, titleStyle }) => {
    const techBottomBannerQuery = useStaticQuery(graphql`
        query techBottomBannerQuery {
            file(relativePath: {eq: "images/banner/technology_bottom_banner.jpg"}) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, quality: 70, placeholder: BLURRED)
                }
            }
        }
    `);

    const imageData = techBottomBannerQuery.file.childImageSharp.gatsbyImageData;
    const title = "Hello there";

    return (
        <Fragment>
            <SectionWrap>
                <GatsbyImage
                    image={imageData}
                    alt=""
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0 }}
                />
                {/*  <Container style={{position: "relative", zIndex: 1}}>
                    <Row>
                        <Col lg={6} md={10} xs={11} ml="auto">
                            <Box>
                                {title && <Heading {...titleStyle}>{parse(title)}</Heading>}
                            </Box>
                        </Col>
                    </Row>
                </Container> */}
            </SectionWrap>
        </Fragment>
    )
}

BottomBannerArea.propTypes = {
    sectionStyle: PropTypes.object,
    titleStyle: PropTypes.object
}

BottomBannerArea.defaultProps = {
    sectionStyle: {

    },
    titleStyle: {
        lineHeight: 1.34,
        fontweight: 600,
        color: '#fff',
        mb: '65px'
    }
}

export default BottomBannerArea;